const _input = (() => {
    const el = document.createElement('input');
    el.type = 'file';
    el.multiple = false;
    return el;
})();
// I'm not use promises here because firefox and safari loose trusted context in async functions
// And never shows upload file popup.
export function fileUploadPrompt(cb, multiple = false, accept) {
    _input.multiple = multiple;
    _input.accept = accept ?? '';
    _input.onclick = () => {
        _input.onchange = () => {
            try {
                if ('files' in _input && _input.files !== null) {
                    const files = Array.from(_input.files);
                    cb(files);
                }
                else {
                    cb([]);
                }
            }
            finally {
                // Fix: event not triggered when same file uploaded again
                _input.value = '';
                _input.onclick = () => { };
                _input.onchange = () => { };
            }
        };
    };
    _input.click();
}
